/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Fail_SubmitInputs */

const vi_cdo_fail_submit = /** @type {(inputs: Cdo_Fail_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận thất bại`)
};

/**

* @param {Cdo_Fail_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_fail_submit = /** @type {((inputs?: Cdo_Fail_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Fail_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_fail_submit(inputs)
});